import React, { lazy } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import ErrorBoundaryPage from "../component/ErrorBoundary/ErrorBoundaryPage";
import { homePage } from "../constants/constants";
import { ToolBoxDataType } from "../interfaces/ToolBoxData";
import { CoachingToolPage } from "../Pages/CoachingTool.tsx/CoachingTool";
import ContactForm from "../Pages/ContactForm/ContactForm";
import ThankYouPage from "../Pages/Coolbag/ThankYouPage";
import { DynamicPage } from "../Pages/DynamicPage/DynamicPage";
import ForgotPasswordPage from "../Pages/ForgotPassword/ForgotPasswordPage";
import { HomePage } from "../Pages/Home/HomePage";
import ChangePassword from "../Pages/ChangePassword/ChangePassword";
import Login from "../Pages/Login/Login";
import { NotFoundPage } from "../Pages/NotFound/NotFoundPage";
import OrderKitForm from "../Pages/OrderKitForm/OrderKitForm";
import RegisterFormHCP from "../Pages/Register/RegisterFormHCP";
import RegisterFormMain from "../Pages/Register/RegisterFormMain";
import RegisterFormPatient from "../Pages/Register/RegisterFormPatient";
import ThankYouForRegisteringPage from "../Pages/Register/ThankYouForRegisteringPage";
import { GoalSettingWrapper } from "../Pages/Toolbox/Goal/GoalSettingsWrapper";
import MyProgresspage from "../Pages/Toolbox/MyProgress/MyProgressPage";
import { ReminderPage } from "../Pages/Toolbox/Reminder/ReminderPage";
import ToolBoxSettingsPage from "../Pages/Toolbox/ToolBoxSettingsPage";
import { YourConditionPage } from "../Pages/YourCondition.tsx/YourConditionPage";
import PrivateRoute from "./PrivateRoute";
import { Restriction } from "../interfaces/Restriction";

const AccountPage = lazy(() => import("../Pages/Profile/ProfilePage"));
const CoolbagForm = lazy(() => import("../Pages/Coolbag/CoolbagForm"));

export const Routes: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <ErrorBoundaryPage>
      <Switch>
        <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
        <Route path={"/" + homePage}>
          <HomePage />
        </Route>
        <Route path="/login/:userType">
          <Login />
        </Route>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/register">
          <RegisterFormMain />
        </Route>
        <Route path="/forgot-password">
          <ForgotPasswordPage />
        </Route>
        <Route path="/change-password">
          <ChangePassword />
        </Route>
        <Route path="/hcp/register">
          <RegisterFormHCP />
        </Route>
        <Route path="/hcp/thank-you">
          <ThankYouForRegisteringPage breadcrumb="For HCPs" />
        </Route>
        <Route path="/patient/register">
          <RegisterFormPatient />
        </Route>
        <Route path="/patient/thank-you">
          <ThankYouForRegisteringPage breadcrumb="For patients" />
        </Route>
        <PrivateRoute path="/profile">
          <AccountPage />
        </PrivateRoute>
        <PrivateRoute path="/Mi-tratamiento/Solicitar-una-nevera-portátil/thank-you" restriction={Restriction.PATIENT}>
          <ThankYouPage />
        </PrivateRoute>
        <PrivateRoute path="/Mi-tratamiento/Solicitar-una-nevera-portátil" restriction={Restriction.PATIENT}>
          <CoolbagForm />
        </PrivateRoute>
        <PrivateRoute
          exact
          path="/Mi-tratamiento/Mi-progreso/Seguimiento-del-tratamiento/settings"
          restriction={Restriction.PATIENT}
        >
          <ToolBoxSettingsPage
            dataType={ToolBoxDataType.MEDICATIONS}
            editPageUrl="/Mi-tratamiento/Mi-progreso/Seguimiento-del-tratamiento/settings/medication/"
            showTime={true}
            showDate={true}
            isMedication={true}
          />
        </PrivateRoute>
        <PrivateRoute exact path="/Mi-tratamiento/Mi-progreso/Establecer-objetivos/settings" restriction={Restriction.PATIENT}>
          <GoalSettingWrapper editPageUrl="/Mi-tratamiento/Mi-progreso/Establecer-objetivos/settings/goal/" />
        </PrivateRoute>
        <Redirect
          from="/Mi-tratamiento/Mi-progreso/Establecer-objetivos"
          to="/Mi-tratamiento/Mi-progreso/Establecer-objetivos/settings"
        />
        <PrivateRoute path="/Mi-tratamiento/Mi-progreso/Establecer-objetivos" restriction={Restriction.PATIENT}>
          <GoalSettingWrapper editPageUrl="/Mi-tratamiento/Mi-progreso/Establecer-objetivos/settings/goal/" />
        </PrivateRoute>
        <PrivateRoute path="/Mi-tratamiento/Mi-progreso/Recordatorios" restriction={Restriction.PATIENT}>
          <ReminderPage />
        </PrivateRoute>
        <Route path="/Bienestar-y-apoyo/Su-bienestar/Herramientas-de-coaching">
          <CoachingToolPage />
        </Route>
        <Route exact path="/Iniciando-el-recorrido/Su-enfermedad">
          <YourConditionPage />
        </Route>
        <PrivateRoute exact path="/Mi-tratamiento/Mi-progreso" restriction={Restriction.PATIENT}>
          <MyProgresspage />
        </PrivateRoute>
        <Route path="/not-found">
          <NotFoundPage />
        </Route>
        <Route exact path="/">
          <Redirect to={homePage} />
        </Route>
        <PrivateRoute exact path="/ACCESO-PARA-PROFESIONALES-DE-LA-SALUD/Hacer-una-solicitud/Solicitar-la-visita-de-un-representante" restriction={Restriction.HCP}>
          <ContactForm />
        </PrivateRoute>
        <PrivateRoute exact path="/ACCESO-PARA-PROFESIONALES-DE-LA-SALUD/Solicitar-la-visita-de-un-representante" restriction={Restriction.HCP}>
          <ContactForm />
        </PrivateRoute>
        <PrivateRoute exact path="/ACCESO-PARA-PROFESIONALES-DE-LA-SALUD/Hacer-una-solicitud/Solicitar-un-kit" restriction={Restriction.HCP}>
          <OrderKitForm />
        </PrivateRoute>
        <PrivateRoute path="/Mi-tratamiento" restriction={Restriction.PATIENT}>
          <DynamicPage />
        </PrivateRoute>
        <PrivateRoute path="/ACCESO-PARA-PROFESIONALES-DE-LA-SALUD" restriction={Restriction.HCP}>
          <DynamicPage />
        </PrivateRoute>
        <Route path="">
          <DynamicPage />
        </Route>
      </Switch>
    </ErrorBoundaryPage>
  );
};
